import type { TextSizeKeys } from '../../../types'
import { textStylesExtra } from '../text-sizes'

export const getExtraTextStyles = (size: TextSizeKeys) => textStylesExtra[size]
